exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.qn-cropper[data-v-0d850c2c] .el-dialog--small {\n  width: 440px;\n}\n.qn-cropper[data-v-0d850c2c] .el-dialog__body {\n  text-align: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0d850c2c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/QnUpload-1.0.0/cropper/index.vue
// module id = teFm
// module chunks = 212